<template>
<div class="chapter">
<div class="inner_page">
<p class="p_autor"><span class="calibre1">Carl Philipp Gottlieb von Clausewitz</span></p>
<p class="p_titel"><span>Vom Kriege</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?2e5640d4